"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBHeaderMobile", {
  enumerable: true,
  get: function get() {
    return _SVBHeaderMobile.default;
  }
});
var _SVBHeaderMobile = _interopRequireDefault(require("./src/SVBHeaderMobile"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }